import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { errorCss } from '../../ui/Form/baseStyles/index.styles';

export const screenContainer = css({
  position: 'relative',
  paddingBottom: 110,
});

export const dateError = css(errorCss, {
  marginTop: 20,
});

export const header = css({
  borderBottom: `1px solid ${colorsPalette.grey20}`,
  paddingBottom: 30,
  [MediaQueries.mdAndUp]: {
    borderBottomWidth: 0,
    paddingBottom: 0,
    marginBottom: 50,
  },
});

export const backButton = css({
  minHeight: 48,
  minWidth: 48,
  border: 0,
  background: colorsPalette.transparent,
  marginTop: 15,
  paddingLeft: 5,
  textAlign: 'left',
  [MediaQueries.mdAndUp]: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: -70,
  },
  [MediaQueries.lgAndUp]: {
    top: -82,
  },
});

export const backButtonIcon = css({
  fontSize: 22,
  [MediaQueries.mdAndUp]: {
    marginRight: 18,
  },
});

export const backButtonLabel = css(typography.effra16, {
  color: colorsPalette.black,
});

export const headline = css(typography.effra58Modal, {
  color: colorsPalette.grey,
  margin: '60px 0 22px',
  position: 'relative',
  [MediaQueries.mdAndUp]: {
    marginTop: 128,
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 170,
  },
});

export const subtitleContainer = css({
  [MediaQueries.mdAndUp]: {
    display: 'flex',
  },
});

export const phoneContainer = css({
  marginTop: 40,
  [MediaQueries.mdAndUp]: {
    marginTop: 10,
  },
  '.phone-container': {
    display: 'flex',
  },
  '.phone-label': {
    flex: 1,
    [MediaQueries.mdAndUp]: {
      flex: 'none',
    },
  },
  '.phone-number': {
    borderBottom: `1px solid ${colorsPalette.grey20}`,
    paddingBottom: 6,
    fontSize: 18,
    [MediaQueries.mdAndUp]: {
      border: 0,
      paddingBottom: 0,
      fontSize: 16,
    },
  },
});

export const location = css(typography.effra22, {
  fontWeight: fontWeights.medium,
  lineHeight: 1.45,
  margin: '22px 0 10px',
});

export const address = css(typography.effra18, {
  color: colorsPalette.grey80,
  lineHeight: 1.6,
});

export const dateInstruction = css(typography.effra16, {
  color: colorsPalette.grey80,
});

export const submitButtonContainer = css({
  backgroundColor: colorsPalette.white,
  boxShadow: `0 0 15px 6px ${colorsPalette.white}`,
  position: 'fixed',
  bottom: 0,
  left: 0,
  width: '100%',
  padding: '24px',
  zIndex: 3,
  [MediaQueries.mdAndUp]: {
    position: 'relative',
    boxShadow: 'none',
    padding: 0,
    maxWidth: 190,
    marginTop: 40,
  },
});

export const timePicker = css({
  maxWidth: 590,
});

export const infoFormContainer = css({
  marginTop: 40,
  '.enquiry-input': {
    marginBottom: 32,
  },
});

export const dropdownContainer = css({
  [MediaQueries.mdAndUp]: {
    display: 'flex',
    '.enquiry-input': {
      flex: 1,
      '&:first-child': {
        marginRight: 20,
      },
    },
  },
});

export const dateSummaryContainer = css({
  display: 'flex',
  margin: '25px 0 50px',
  [MediaQueries.mdAndUp]: {
    textAlign: 'center',
  },
});

export const dateSummaryLeftItem = css({
  borderRight: `1px solid ${colorsPalette.grey20}`,
  paddingRight: 35,
});

export const dateSummaryRightItem = css({
  paddingLeft: 35,
});

export const dateSummaryLabel = css(typography.effra16, {
  wordBreak: 'break-all',
  display: 'block',
  color: colorsPalette.grey60,
});

export const dateSummaryValue = css(typography.effra18, {
  fontWeight: fontWeights.medium,
  color: colorsPalette.black,
});
